import React from 'react';

import { useTranslation } from 'react-i18next';
import Paragraph from '../../uiKit/typography/paragraph';
import { ReactComponent as SettingsIcon} from '../../assets/icons/bult/settings.svg'
import { ReactComponent as AnalyticsIcon} from '../../assets/icons/bult/analytics.svg'
import { ReactComponent as EarthIcon} from '../../assets/icons/bult/Earth.svg'
import { ReactComponent as PuzzleRightIcon} from '../../assets/icons/bult/puzzle-right.svg'


export default React.memo(function BuiltBlock({
                                                 children, slideWidth = 260, speed = 10,
                                                 className = '', containerClassName = '',
                                                 direction = 'left'
                                               }) {
  const { t } = useTranslation('common');

  const tempData = [{
    icon: SettingsIcon,
    title: 'Fast API Integration',
    description: 'Our tech enables full setup in days, not weeks.'
  },
    {
      icon: AnalyticsIcon,
      title: 'Actionable Analytics',
      description: 'Track performance and player behaviour in real time.'
    },
    {
      icon: EarthIcon,
      title: 'Dynamic Content',
      description: 'Game content that adapts to your market and audience.'
    },
    {
      icon: PuzzleRightIcon,
      title: 'Localized for Markets',
      description: 'Available in 20+ languages. Regulation-ready.'
    }]


  return (<>
      <Paragraph className={'text-center text-black text-3xl mb-8'}>
        {t('titles.built')}
      </Paragraph>
      <div className={'flex w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'}>
        {tempData.map((card,index) => (<div key={index}
          className="w-full  gap-4 px-10 py-8 bg-white border border-gray-200 rounded-[10px]">
          {<card.icon />}
          <h6 className="mt-5 mb-1 text-base font-medium text-black leading-[2.06] ">{card.title}</h6>
          <p className="font-normal/8 text-black/70">{card.description}</p>
        </div>)
        )}
      </div>

    </>

  )
})
